export const OLD_I18N_STORAGE_KEY = "i18nextLng";
